"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authPromoContract = void 0;
const dbJsonModels_1 = require("@daymade/common-lib/dbJsonModels");
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.authPromoContract = c.router({
    getUpgradeOffer: {
        method: 'GET',
        path: '/upgrade-offer',
        query: zod_1.z.object({
            planCode: zod_1.z.optional(zod_1.z.string()).nullable(),
        }),
        responses: {
            200: zod_1.z.object({
                promoCode: zod_1.z.optional(models_1.ZPromoCodeSelect),
            }),
            400: c.type(),
            404: c.type(),
        },
        summary: 'Get prize wins of a draw',
    },
    getCancellationOffer: {
        method: 'GET',
        path: '/cancellation-offer',
        query: zod_1.z.object({
            planCode: zod_1.z.optional(zod_1.z.string()).nullable(),
        }),
        responses: {
            200: zod_1.z.object({
                promoCode: zod_1.z.optional(models_1.ZPromoCodeSelect),
            }),
            400: c.type(),
            404: c.type(),
        },
        summary: 'Get cancellation offer promo code',
    },
    activatePromoCodeForSubscription: {
        method: 'POST',
        path: '/activate-promo-code',
        body: zod_1.z.object({
            subscriptionId: zod_1.z.string(),
            code: zod_1.z.string(),
            evalData: zod_1.z.optional(dbJsonModels_1.ZPromoConditions.partial()),
        }),
        responses: {
            200: zod_1.z.object({
                promoCodeRecurring: models_1.ZPromoCodeRecurringSelect,
            }),
            400: c.type(),
        },
        summary: 'Activate a promo code for a subscription',
    },
}, {
    pathPrefix: '/auth',
    strictStatusCodes: true,
    commonResponses: {
        401: c.type(),
        403: c.type(),
    },
});
//# sourceMappingURL=promo.auth.contract.js.map